<template>
  <div class="l-header-navigation">
    <ul class="navigation">
      <li class="navigation-item">
        <a href="/">
          <span class="navigation-item-inner">企業サイト トップ</span>
        </a>
      </li>
      <li
        class="navigation-item js-header-navigation-about"
        v-on:mouseover="open"
        v-on:mouseleave="close"
      >
        <a href="/about/">
          <span class="navigation-item-inner">会社情報</span>
        </a>
      </li>
      <li class="navigation-item">
        <a href="/business/">
          <span class="navigation-item-inner">事業案内</span>
        </a>
      </li>
      <li class="navigation-item js-header-navigation-ir is-current is-hover">
        <a href="/ir/index">
          <span class="navigation-item-inner">IR情報</span>
        </a>
      </li>

      <li class="navigation-item">
        <a href="/news/">
          <span class="navigation-item-inner">ニュース</span>
        </a>
      </li>
      <li class="navigation-item">
        <a href="/csr/">
          <span class="navigation-item-inner">CSR</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import jQuery from "jquery";

export default {
  methods: {
    open: function () {
      jQuery(".js-header-navigation-about").addClass("is-open");
      jQuery("#js-navigation-children-about").eq(0).addClass("is-hover");
    },
    close: function () {
      jQuery(".js-header-navigation-about").removeClass("is-open");
      jQuery("#js-navigation-children-about").eq(0).removeClass("is-hover");
    },
  },
};
</script>
